import cloneDeep from 'lodash/cloneDeep';
import { put, fork, take, select } from 'redux-saga/effects';
import { locationHelpers } from 'ng-redux-route';
import { takeFetch } from 'redux/helpers';
import * as serviceActions from '../../../../services/actions';
import * as projectActions from '../../../project/actions';
import * as actions from './actions';
import * as fieldsetActions from './fieldset/actions';
import fieldsetSaga from './fieldset/saga';

function* getProject() {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.GET);
  if (success) {
    yield put(fieldsetActions.init.begin({ project: success.data}));
  } else {
    ttb.Notifications.ShowErrorMessage('Error', 'Url is not valid or you do not have the access to this configuration item');
    yield put(locationHelpers.setUrl('/configuration/project', true));
  }
}

function* updateProject() {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.UPSERT);
  if (success) {
    const { project } = yield select(state => state.configuration.project.editor.general.fieldset);
    yield put(fieldsetActions.save({ project: cloneDeep(project) }));
    ttb.Notifications.ShowSaveSuccessMessage('Project Configuration', 'All the changes have been saved');
    yield put(projectActions.viewer.init.begin());
  } else {
    ttb.Notifications.ShowErrorMessage('Project Configuration', 'The changes have not been saved');
  }
}

function* init() {
  while (true) {
    const { projectId } = yield take(actions.INIT);
    yield put(serviceActions.api.configuration.project.get.request({
      id: projectId,
    }));
    yield fork(getProject);
  }
}

function* setTab() {
  while (true) {
    const { value, setUrl } = yield take(actions.SET_TAB);
    if (setUrl) {
      const { projectId } = yield select(state => state.configuration.project.editor.general);
      yield put(locationHelpers.setUrl(`/configuration/project/edit/${projectId}/${value}`, true));
    }
  }
}

function* save() {
  while (true) {
    const fields = yield take(actions.SAVE);
    yield put(serviceActions.api.configuration.project.upsert.request(fields));
    yield fork(updateProject);
  }
}

export default function* general() {
  yield fork(init);
  yield fork(setTab);
  yield fork(save);
  yield fork(fieldsetSaga);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/general/saga.js